import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class UsersResource {
    baseUrl: string;
    resourceName = 'users';

    constructor(private http: HttpClient) {
        this.baseUrl = [environment.baseUrl, 'v2', this.resourceName].join('/');
    }

    getAll(): Observable<any> {
        return this.http.get<any>(this.baseUrl + '/');
    }

    getById(id: string): Observable<any> {
        return this.http.get<any>(this.baseUrl + '/' + id);
    }

    search(email: string): Observable<any> {
        return this.http.get<any>(this.baseUrl + '/search?email=' + email);
    }

    getProfile(): Observable<any> {
        return this.http.get<any>(this.baseUrl + '/profile');
    }

    updateProfile(body: any) {
        return this.http.put<any>(this.baseUrl + '/profile', body);
    }

    delete(id: string): Observable<any> {
        return this.http.delete<any>(this.baseUrl + '/' + id);
    }

    callback(): Observable<any> {
        const url = new URL(this.baseUrl + `/callback`);
        return this.http.post<any>(url.toString(), {});
    }
}
